// import React, { useEffect, useState } from "react";
// import Input from "../../../../../../components/Elements/Input/Input";
// import { Button, Select } from "antd";
// import OrganizationDocumentsUpload from "./OrganizationDocumentsUpload";
// import BillingDocumentsUpload from "./BillingDocumentsUpload";
// import { useSelector } from "react-redux";
// import { getApi } from "../../../../../../api/api_instance";
// import { API_URLS } from "../../../../../../api/apiUrls";
// import OrganizationDocumentsView from "./OrganizationDocumentsView";

// const countryCodes = [
//   { label: "US (+1)", value: "+1" },
//   { label: "UK (+44)", value: "+44" },
//   { label: "IND (+91)", value: "+91" },
//   { label: "AUS (+61)", value: "+61" },
//   { label: "CAN (+1)", value: "+1" },
//   { label: "GER (+49)", value: "+49" },
//   { label: "FRA (+33)", value: "+33" },
//   { label: "JAP (+81)", value: "+81" },
// ];

// const countries = [
//   { label: "United States", value: "United States" },
//   { label: "Canada", value: "Canada" },
//   { label: "United Kingdom", value: "United Kingdom" },
//   { label: "India", value: "India" },
//   { label: "Germany", value: "Germany" },
//   { label: "France", value: "France" },
//   { label: "Australia", value: "Australia" },
// ];

// const OrganizationDetails = () => {
//   const token = useSelector((state) => state.auth.authToken);
//   const [billingDetails, setBillingDetails] = useState({
//     organizationName: "",
//     AddressDetails: {
//       AddressLine: "",
//       city: "",
//       state: "",
//       Country: "",
//       Pincode: "",
//     },
//   });
//   const [organizationDetails, setOrganizationDetails] = useState({
//     organizationName: "",
//     AddressDetails: {
//       AddressLine: "",
//       city: "",
//       state: "",
//       Country: "",
//       Pincode: "",
//     },
//     organizationContactDetails: {
//       website: "",
//       contactNumber: {
//         countryCode: "",
//         phoneNumber: "",
//         otp: "",
//       },
//     },
//     organizationemail: {
//       email_id: "",
//       otp: "",
//     },
//     natureOfBusiness: "",
//   });

//   const [documents, setDouments] = useState({});

//   // const [uploadBillingDocuments, setUploadBillingDocuments] = useState({
//   //   CIN: { number: "", file: null },
//   //   VAT: { number: "", file: null },
//   //   DUNS: { number: "", file: null },
//   // });

//   // const [uploadOrganizationDocuments, setUploadOrganizationDocuments] =
//   //   useState({
//   //     CIN: { number: "", file: null },
//   //     VAT: { number: "", file: null },
//   //     PAN: { number: "", file: null },
//   //     DUNS: { number: "", file: null },
//   //   });

//   const fetchDetails = async () => {
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_KYC_DETAILS,
//         token: token,
//       });
//       if (response.success) {
//         const data = response.data;
//         setOrganizationDetails({
//           organizationName: data.organization.orgInfo.OrganizationName,
//           AddressDetails: {
//             AddressLine: data.organization.orgInfo.addressDetails.AddressLine,
//             city: data.organization.orgInfo.addressDetails.City,
//             state: data.organization.orgInfo.addressDetails.State,
//             Country: data.organization.orgInfo.addressDetails.Country,
//             Pincode: data.organization.orgInfo.addressDetails.Pincode,
//           },
//           organizationContactDetails: {
//             website: data.organization.orgInfo.orgContactDetails.WebsiteLink,
//             contactNumber: {
//               countryCode:
//                 data.organization.orgInfo.orgContactDetails.org_mobile_no
//                   .PhoneCode,
//               phoneNumber:
//                 data.organization.orgInfo.orgContactDetails.org_mobile_no
//                   .ContactNumber,
//               otp: "",
//             },
//           },
//           organizationemail: {
//             email_id: data.organization.orgInfo.orgContactDetails.Email,
//             otp: "",
//           },
//           natureOfBusiness: data.organization.orgInfo.NatureOfBussiness,
//         });
//         setBillingDetails({
//           organizationName:
//             data.organization.orgBillingInfo.BillingOrganizationName,
//           AddressDetails: {
//             AddressLine:
//               data.organization.orgBillingInfo.billingAddress.AddressLine,
//             city: data.organization.orgBillingInfo.billingAddress.City,
//             state: data.organization.orgBillingInfo.billingAddress.State,
//             Country: data.organization.orgBillingInfo.billingAddress.Country,
//             Pincode: data.organization.orgBillingInfo.billingAddress.Pincode,
//           },
//         });
//         setDouments(data.organization.org_documents);
//       }
//     } catch (error) {
//       console.log("Unable to get data", error);
//     }
//   };

//   const handleChangeOrganizationDetails = (e) => {
//     setOrganizationDetails({
//       ...organizationDetails,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleChangeBillingDetails = (e) => {
//     setBillingDetails({
//       ...organizationDetails,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleCountryChange = (value) => {
//     setOrganizationDetails((prev) => ({
//       ...prev,
//       AddressDetails: {
//         ...prev.AddressDetails,
//         Country: value,
//       },
//     }));
//   };

//   // const handleOrganizationDocumentChange = (key, field, value) => {
//   //   setUploadOrganizationDocuments((prev) => ({
//   //     ...prev,
//   //     [key]: {
//   //       ...prev[key],
//   //       [field]: value,
//   //     },
//   //   }));
//   // };

//   // const handleBillingDocumentChange = (key, field, value) => {
//   //   setUploadBillingDocuments((prev) => ({
//   //     ...prev,
//   //     [key]: {
//   //       ...prev[key],
//   //       [field]: value,
//   //     },
//   //   }));
//   // };

//   useEffect(() => {
//     if (token) {
//       fetchDetails();
//     }
//   }, []);

//   return (
//     <div style={{ backgroundColor: "#fff" }} className="py-2">
//       <div className="px-10">
//         {/* Organization Section */}
//         <label className="block font-normal text-gray-500">
//           Organization Name
//         </label>
//         <Input
//           type="text"
//           readOnly
//           name="organizationName"
//           value={organizationDetails.organizationName}
//           onChange={handleChangeOrganizationDetails}
//           className="w-96"
//           variant="secondary"
//         />

//         {/* Address Details */}
//         <label className="pt-10 block font-normal text-gray-500">
//           Address Details
//         </label>
//         <div className="flex justify-between gap-5">
//           <Input
//             type="text"
//             name="AddressLine"
//             readOnly
//             value={organizationDetails.AddressDetails.AddressLine}
//             onChange={handleChangeOrganizationDetails}
//             className="w-60"
//             placeholder="Address Line"
//             variant="secondary"
//           />
//           <Input
//             type="text"
//             name="city"
//             readOnly
//             value={organizationDetails.AddressDetails.city}
//             onChange={handleChangeOrganizationDetails}
//             className="w-60"
//             placeholder="City"
//             variant="secondary"
//           />
//           <Input
//             type="text"
//             name="state"
//             readOnly
//             value={organizationDetails.AddressDetails.state}
//             onChange={handleChangeOrganizationDetails}
//             className="w-60"
//             placeholder="State"
//             variant="secondary"
//           />
//         </div>
//         <div className="flex gap-5 pt-4">
//           {/* <Select
//             showSearch
//             disabled
//             placeholder=""
//             className="w-60"
//             options={countries}
//             value={organizationDetails.AddressDetails.Country}
//             onChange={handleCountryChange}
//           /> */}
//           <select
//             disabled
//             value={organizationDetails.AddressDetails.Country}
//             onChange={handleCountryChange}
//             className="w-60   border-b-[2px] border-gray-300 focus:outline-none"
//           >
//             <option>Select a country</option>
//             {countries.map((country, index) => (
//               <option key={index} value={country.value}>
//                 {country.label}
//               </option>
//             ))}
//           </select>
//           <Input
//             type="text"
//             name="pincode"
//             disabled
//             value={organizationDetails.AddressDetails.Pincode}
//             onChange={handleChangeOrganizationDetails}
//             className="w-60"
//             placeholder="Pin Code"
//             variant="secondary"
//           />
//         </div>

//         {/* Upload Documents Section */}
//         {/* <OrganizationDocumentsUpload
//           uploadDocuments={uploadOrganizationDocuments}
//           handleDocumentChange={handleOrganizationDocumentChange}
//         /> */}

//         <OrganizationDocumentsView documents={documents} />

//         {/* Organization Contact Details */}
//         <label className="pt-10 block  font-normal text-gray-500">
//           Organization Contact Details
//         </label>
//         <Input
//           type="text"
//           readOnly
//           value={organizationDetails.organizationContactDetails.website}
//           onChange={handleChangeOrganizationDetails}
//           className="w-60"
//           placeholder="Website"
//           variant="secondary"
//         />

//         <div className="flex gap-4 pt-8">
//           <Select
//             showSearch
//             disabled
//             placeholder="Select Country Code"
//             className="w-20"
//             options={countryCodes}
//             value={
//               organizationDetails.organizationContactDetails.contactNumber
//                 .countryCode
//             }
//             onChange={handleChangeOrganizationDetails}
//           />
//           <Input
//             type="text"
//             placeholder="Phone Number"
//             readOnly
//             className="w-56"
//             value={
//               organizationDetails.organizationContactDetails.contactNumber
//                 .phoneNumber
//             }
//             onChange={handleChangeOrganizationDetails}
//             variant="secondary"
//           />
//           <div className="text-[#06513D] rounded-full border-2 items-center border-[#06513D]">
//             <p className="pt-3 px-4">Send Code</p>
//           </div>
//           <Input
//             type="text"
//             className="w-28"
//             value={
//               organizationDetails.organizationContactDetails.contactNumber.otp
//             }
//             onChange={handleChangeOrganizationDetails}
//             placeholder="OTP"
//             variant="secondary"
//           />

//           <div className="text-[#06513D] rounded-full border-2 items-center border-[#06513D]">
//             <p className="pt-3 px-4">Verify</p>
//           </div>
//         </div>
//         <div className="flex gap-4 pt-8">
//           <Input
//             type="text"
//             placeholder="Email Id"
//             readOnly
//             className="w-56"
//             value={organizationDetails.organizationemail.email_id}
//             onChange={handleChangeOrganizationDetails}
//             variant="secondary"
//           />
//           <div className="text-[#06513D] rounded-full border-2 items-center border-[#06513D]">
//             <p className="pt-3 px-4">Send Code</p>
//           </div>
//           <Input
//             type="text"
//             className="w-28"
//             value={organizationDetails.organizationemail.otp}
//             onChange={handleChangeOrganizationDetails}
//             placeholder="OTP"
//             variant="secondary"
//           />

//           <div className="text-[#06513D] rounded-full border-2 items-center border-[#06513D]">
//             <p className="pt-3 px-4">Verify</p>
//           </div>
//         </div>

//         <label className="pt-10 pb-4 block  font-normal text-gray-500">
//           Explain About Nature Of Business
//         </label>
//         <textarea
//           type="text"
//           readOnly
//           value={organizationDetails.natureOfBusiness}
//           onChange={handleChangeOrganizationDetails}
//           className=" border-2 rounded-xl w-full h-28 focus:outline-none p-4"
//         />

//         <h4 className="text-2xl font-semibold my-7">Billing Information</h4>

//         <label className="block font-normal text-gray-500">
//           Organization Name
//         </label>
//         <Input
//           type="text"
//           readOnly
//           name="organizationName"
//           value={billingDetails.organizationName}
//           onChange={handleChangeBillingDetails}
//           className="w-96"
//           variant="secondary"
//         />

//         <label className="pt-10 block font-normal text-gray-500">
//           Address Details
//         </label>
//         <div className="flex justify-between gap-5">
//           <Input
//             type="text"
//             readOnly
//             name="AddressLine"
//             value={billingDetails.AddressDetails.AddressLine}
//             onChange={handleChangeBillingDetails}
//             className="w-60"
//             placeholder="Address Line"
//             variant="secondary"
//           />
//           <Input
//             type="text"
//             readOnly
//             name="city"
//             value={billingDetails.AddressDetails.city}
//             onChange={handleChangeBillingDetails}
//             className="w-60"
//             placeholder="City"
//             variant="secondary"
//           />
//           <Input
//             type="text"
//             readOnly
//             name="state"
//             value={billingDetails.AddressDetails.state}
//             onChange={handleChangeBillingDetails}
//             className="w-60"
//             placeholder="State"
//             variant="secondary"
//           />
//         </div>
//         <div className="flex gap-5 pt-4">
//           <select
//             placeholder="Country"
//             className="w-60   border-b-[2px] border-gray-300 focus:outline-none"
//             disabled
//             value={billingDetails.AddressDetails.Country}
//             onChange={handleCountryChange}
//           >
//             <option>Select a country</option>
//             {countries.map((country, index) => (
//               <option key={index} value={country.value}>
//                 {country.label}
//               </option>
//             ))}
//           </select>
//           <Input
//             type="text"
//             name="pincode"
//             readOnly
//             value={billingDetails.AddressDetails.Pincode}
//             onChange={handleChangeBillingDetails}
//             className="w-60 border-b border-none"
//             placeholder="Pin Code"
//             variant="secondary"
//           />
//         </div>
//         {/* <BillingDocumentsUpload
//           uploadDocuments={uploadBillingDocuments}
//           handleDocumentChange={handleBillingDocumentChange}
//         /> */}

//         <div className="text-center my-8">
//           <Button
//             type="secondary"
//             className=" text-white bg-[#06513D] text-sm px-10 py-5"
//           >
//             Save
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default OrganizationDetails;

import React, { useEffect, useState } from "react";
//import Input from "../../../../../../components/Elements/Input/Input";
import Input from "../../../../../components/Elements/Input/Input";
import { Button, Select } from "antd";
import OrganizationDocumentsUpload from "./OrganizationDocumentsUpload";
import BillingDocumentsUpload from "./BillingDocumentsUpload";
import { useSelector } from "react-redux";
// import { getApi } from "../../../../../../api/api_instance";
// import { API_URLS } from "../../../../../../api/apiUrls";
import { getApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import OrganizationDocumentsView from "./OrganizationDocumentsView";

const countryCodes = [
  { label: "US (+1)", value: "+1" },
  { label: "UK (+44)", value: "+44" },
  { label: "IND (+91)", value: "+91" },
  { label: "AUS (+61)", value: "+61" },
  { label: "CAN (+1)", value: "+1" },
  { label: "GER (+49)", value: "+49" },
  { label: "FRA (+33)", value: "+33" },
  { label: "JAP (+81)", value: "+81" },
];

const countries = [
  { label: "United States", value: "United States" },
  { label: "Canada", value: "Canada" },
  { label: "United Kingdom", value: "United Kingdom" },
  { label: "India", value: "India" },
  { label: "Germany", value: "Germany" },
  { label: "France", value: "France" },
  { label: "Australia", value: "Australia" },
];

const OrganizationDetails = () => {
  const token = useSelector((state) => state.auth.authToken);
  const user = useSelector((state) => state.auth.user);

  // Check sub-admin write permission for the profile module
  const profilePermission = user?.subAdmin?.permissions?.find(
    (p) => p.module === "profile",
  );
  const hasWriteAccess =
    !user?.subAdmin?.isSubAdmin || profilePermission?.access === "write";
  const [billingDetails, setBillingDetails] = useState({
    organizationName: "",
    AddressDetails: {
      AddressLine: "",
      city: "",
      state: "",
      Country: "",
      Pincode: "",
    },
  });
  const [organizationDetails, setOrganizationDetails] = useState({
    organizationName: "",
    AddressDetails: {
      AddressLine: "",
      city: "",
      state: "",
      Country: "",
      Pincode: "",
    },
    organizationContactDetails: {
      website: "",
      contactNumber: {
        countryCode: "",
        phoneNumber: "",
        otp: "",
      },
    },
    organizationemail: {
      email_id: "",
      otp: "",
    },
    natureOfBusiness: "",
  });

  const [documents, setDouments] = useState({});

  const fetchDetails = async () => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_KYC_DETAILS,
        token: token,
      });
      if (response.success) {
        const data = response.data;
        setOrganizationDetails({
          organizationName: data.organization.orgInfo.OrganizationName,
          AddressDetails: {
            AddressLine: data.organization.orgInfo.addressDetails.AddressLine,
            city: data.organization.orgInfo.addressDetails.City,
            state: data.organization.orgInfo.addressDetails.State,
            Country: data.organization.orgInfo.addressDetails.Country,
            Pincode: data.organization.orgInfo.addressDetails.Pincode,
          },
          organizationContactDetails: {
            website: data.organization.orgInfo.orgContactDetails.WebsiteLink,
            contactNumber: {
              countryCode:
                data.organization.orgInfo.orgContactDetails.org_mobile_no
                  .PhoneCode,
              phoneNumber:
                data.organization.orgInfo.orgContactDetails.org_mobile_no
                  .ContactNumber,
              otp: "",
            },
          },
          organizationemail: {
            email_id: data.organization.orgInfo.orgContactDetails.Email,
            otp: "",
          },
          natureOfBusiness: data.organization.orgInfo.NatureOfBussiness,
        });
        setBillingDetails({
          organizationName:
            data.organization.orgBillingInfo.BillingOrganizationName,
          AddressDetails: {
            AddressLine:
              data.organization.orgBillingInfo.billingAddress.AddressLine,
            city: data.organization.orgBillingInfo.billingAddress.City,
            state: data.organization.orgBillingInfo.billingAddress.State,
            Country: data.organization.orgBillingInfo.billingAddress.Country,
            Pincode: data.organization.orgBillingInfo.billingAddress.Pincode,
          },
        });
        setDouments(data.organization.org_documents);
      }
    } catch (error) {
      console.log("Unable to get data", error);
    }
  };

  const handleChangeOrganizationDetails = (e) => {
    setOrganizationDetails({
      ...organizationDetails,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeBillingDetails = (e) => {
    setBillingDetails({
      ...organizationDetails,
      [e.target.name]: e.target.value,
    });
  };

  const handleCountryChange = (value) => {
    setOrganizationDetails((prev) => ({
      ...prev,
      AddressDetails: {
        ...prev.AddressDetails,
        Country: value,
      },
    }));
  };

  useEffect(() => {
    if (token) {
      fetchDetails();
    }
  }, []);

  return (
    <div
      style={{ backgroundColor: "#fff", borderRadius: "10px" }}
      className="py-2"
    >
      <div className="px-4 sm:px-6 lg:px-10 max-w-7xl mx-auto">
        {/* Organization Section */}
        <div className="mb-6">
          <label className="block font-normal text-gray-500 mb-2">
            Organization Name
          </label>
          <Input
            type="text"
            readOnly
            name="organizationName"
            value={organizationDetails.organizationName}
            onChange={handleChangeOrganizationDetails}
            className="w-full max-w-md"
            variant="secondary"
          />
        </div>

        {/* Address Details */}
        <div className="mb-6">
          <label className="block font-normal text-gray-500 mb-4">
            Address Details
          </label>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
            <Input
              type="text"
              name="AddressLine"
              readOnly
              value={organizationDetails.AddressDetails.AddressLine}
              onChange={handleChangeOrganizationDetails}
              className="w-full"
              placeholder="Address Line"
              variant="secondary"
            />
            <Input
              type="text"
              name="city"
              readOnly
              value={organizationDetails.AddressDetails.city}
              onChange={handleChangeOrganizationDetails}
              className="w-full"
              placeholder="City"
              variant="secondary"
            />
            <Input
              type="text"
              name="state"
              readOnly
              value={organizationDetails.AddressDetails.state}
              onChange={handleChangeOrganizationDetails}
              className="w-full"
              placeholder="State"
              variant="secondary"
            />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <select
              disabled
              value={organizationDetails.AddressDetails.Country}
              onChange={handleCountryChange}
              className="w-full border-b-[2px] border-gray-300 focus:outline-none py-2"
            >
              <option>Select a country</option>
              {countries.map((country, index) => (
                <option key={index} value={country.value}>
                  {country.label}
                </option>
              ))}
            </select>
            <Input
              type="text"
              name="pincode"
              disabled
              value={organizationDetails.AddressDetails.Pincode}
              onChange={handleChangeOrganizationDetails}
              className="w-full"
              placeholder="Pin Code"
              variant="secondary"
            />
          </div>
        </div>

        {/* Upload Documents Section */}
        <div className="mb-6">
          <OrganizationDocumentsView documents={documents} />
        </div>

        {/* Organization Contact Details */}
        <div className="mb-6">
          <label className="block font-normal text-gray-500 mb-4">
            Organization Contact Details
          </label>
          <div className="mb-4">
            <Input
              type="text"
              readOnly
              value={organizationDetails.organizationContactDetails.website}
              onChange={handleChangeOrganizationDetails}
              className="w-full max-w-md"
              placeholder="Website"
              variant="secondary"
            />
          </div>

          {/* Phone Number Section */}
          <div className="mb-4">
            <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
              <div className="flex gap-2 w-full sm:w-auto">
                <Select
                  showSearch
                  disabled
                  placeholder="Select Country Code"
                  className="w-20 flex-shrink-0"
                  options={countryCodes}
                  value={
                    organizationDetails.organizationContactDetails.contactNumber
                      .countryCode
                  }
                  onChange={handleChangeOrganizationDetails}
                />
                <Input
                  type="text"
                  placeholder="Phone Number"
                  readOnly
                  className="flex-1 min-w-0"
                  value={
                    organizationDetails.organizationContactDetails.contactNumber
                      .phoneNumber
                  }
                  onChange={handleChangeOrganizationDetails}
                  variant="secondary"
                />
              </div>
              <div className="flex gap-2 w-full sm:w-auto">
                <button className="text-[#06513D] rounded-full border-2 border-[#06513D] px-4 py-2 whitespace-nowrap text-sm">
                  Send Code
                </button>
                <Input
                  type="text"
                  className="w-20 flex-shrink-0"
                  value={
                    organizationDetails.organizationContactDetails.contactNumber
                      .otp
                  }
                  onChange={handleChangeOrganizationDetails}
                  placeholder="OTP"
                  variant="secondary"
                />
                <button className="text-[#06513D] rounded-full border-2 border-[#06513D] px-4 py-2 whitespace-nowrap text-sm">
                  Verify
                </button>
              </div>
            </div>
          </div>

          {/* Email Section */}
          <div className="mb-4">
            <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
              <Input
                type="text"
                placeholder="Email Id"
                readOnly
                className="w-full sm:w-auto min-w-0 flex-1"
                value={organizationDetails.organizationemail.email_id}
                onChange={handleChangeOrganizationDetails}
                variant="secondary"
              />
              <div className="flex gap-2 w-full sm:w-auto">
                <button className="text-[#06513D] rounded-full border-2 border-[#06513D] px-4 py-2 whitespace-nowrap text-sm">
                  Send Code
                </button>
                <Input
                  type="text"
                  className="w-20 flex-shrink-0"
                  value={organizationDetails.organizationemail.otp}
                  onChange={handleChangeOrganizationDetails}
                  placeholder="OTP"
                  variant="secondary"
                />
                <button className="text-[#06513D] rounded-full border-2 border-[#06513D] px-4 py-2 whitespace-nowrap text-sm">
                  Verify
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Nature of Business */}
        <div className="mb-6">
          <label className="block font-normal text-gray-500 mb-4">
            Explain About Nature Of Business
          </label>
          <textarea
            type="text"
            readOnly
            value={organizationDetails.natureOfBusiness}
            onChange={handleChangeOrganizationDetails}
            className="border-2 rounded-xl w-full h-28 focus:outline-none p-4 resize-none"
          />
        </div>

        {/* Billing Information */}
        <div className="mb-6">
          <h4 className="text-xl sm:text-2xl font-semibold my-7">
            Billing Information
          </h4>

          <div className="mb-6">
            <label className="block font-normal text-gray-500 mb-2">
              Organization Name
            </label>
            <Input
              type="text"
              readOnly
              name="organizationName"
              value={billingDetails.organizationName}
              onChange={handleChangeBillingDetails}
              className="w-full max-w-md"
              variant="secondary"
            />
          </div>

          <div className="mb-6">
            <label className="block font-normal text-gray-500 mb-4">
              Address Details
            </label>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
              <Input
                type="text"
                readOnly
                name="AddressLine"
                value={billingDetails.AddressDetails.AddressLine}
                onChange={handleChangeBillingDetails}
                className="w-full"
                placeholder="Address Line"
                variant="secondary"
              />
              <Input
                type="text"
                readOnly
                name="city"
                value={billingDetails.AddressDetails.city}
                onChange={handleChangeBillingDetails}
                className="w-full"
                placeholder="City"
                variant="secondary"
              />
              <Input
                type="text"
                readOnly
                name="state"
                value={billingDetails.AddressDetails.state}
                onChange={handleChangeBillingDetails}
                className="w-full"
                placeholder="State"
                variant="secondary"
              />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <select
                placeholder="Country"
                className="w-full border-b-[2px] border-gray-300 focus:outline-none py-2"
                disabled
                value={billingDetails.AddressDetails.Country}
                onChange={handleCountryChange}
              >
                <option>Select a country</option>
                {countries.map((country, index) => (
                  <option key={index} value={country.value}>
                    {country.label}
                  </option>
                ))}
              </select>
              <Input
                type="text"
                name="pincode"
                readOnly
                value={billingDetails.AddressDetails.Pincode}
                onChange={handleChangeBillingDetails}
                className="w-full"
                placeholder="Pin Code"
                variant="secondary"
              />
            </div>
          </div>
        </div>

        {/* Save Button */}
        {hasWriteAccess && (
          <div className="text-center my-8">
            <Button
              type="secondary"
              className="text-white bg-[#06513D] text-sm px-6 sm:px-10 py-3 sm:py-5 w-full sm:w-auto"
            >
              Save
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrganizationDetails;
